import React from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import TextField from '../common/TextField';

const required = (value) => (value && value !== '' ? undefined : 'Required');

function RemindPasswordForm(props) {
  const { handleSubmit, pristine, submitting } = props;

  return (
    <form onSubmit={handleSubmit} className="customForm remind-password-form">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Field
            name="Login"
            component={TextField}
            label="Login"
            placeholder="Enter your Login"
            validate={required}
          />
        </Grid>
      </Grid>
      <button type="submit" className="submit-button" disabled={pristine || submitting}>
        Restore password
      </button>
    </form>
  );
}

RemindPasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  submitting: PropTypes.bool,
};

RemindPasswordForm.defaultProps = {
  handleSubmit: undefined,
  pristine: undefined,
  submitting: undefined,
};

export default reduxForm({
  form: 'RemindPasswordForm',
})(RemindPasswordForm);
